"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StandardService = void 0;
var uniq_1 = __importDefault(require("lodash/uniq"));
var base_service_1 = require("../base.service");
var insync_assess_sdk_1 = require("@greatmindsorg/insync-assess-sdk");
var standard_serializer_1 = require("../serializers/standard.serializer");
var api_constants_1 = require("../../constants/api.constants");
var dp_standards_standards_sdk_1 = require("@greatmindsorg/dp-standards-standards-sdk");
var dp_http_client_lib_1 = require("@greatmindsorg/dp-http-client-lib");
var StandardService = /** @class */ (function (_super) {
    __extends(StandardService, _super);
    function StandardService(options, itemStandardClient, standardItemClient, standardSerializer, standardItemSerializer, standardApiV2Client) {
        var _this = _super.call(this, options) || this;
        _this.itemStandardClient = itemStandardClient;
        _this.standardItemClient = standardItemClient;
        _this.standardSerializer = standardSerializer;
        _this.standardItemSerializer = standardItemSerializer;
        _this.standardApiV2Client = standardApiV2Client;
        return _this;
    }
    StandardService.newInstance = function (options) {
        var standardSerializer = new standard_serializer_1.StandardSerializer();
        var standardItemSerializer = new dp_standards_standards_sdk_1.StandardItemSerializer();
        var itemStandardClient = insync_assess_sdk_1.ItemStandardClient.newInstance({
            baseURL: api_constants_1.ASSESSMENTS_API_BASE_URL,
        }, options.retryOptionsOnNonAuthorized);
        var standardItemClient = dp_standards_standards_sdk_1.StandardItemClient.newInstance({
            baseURL: api_constants_1.STANDARDS_API_BASE_URL,
        }, options.retryOptionsOnNonAuthorized);
        var standardApiV2Client = dp_http_client_lib_1.RetryableHttpClient.newInstance({
            baseURL: api_constants_1.STANDARDS_API_V2_BASE_URL,
        }, options.retryOptionsOnNonAuthorized);
        return new StandardService(options, itemStandardClient, standardItemClient, standardSerializer, standardItemSerializer, standardApiV2Client);
    };
    StandardService.prototype.findByExternalItemId = function (externalItemIds, filters, curriculumId) {
        return __awaiter(this, void 0, void 0, function () {
            var itemStandards;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.itemStandardClient.findByExternalItemId(externalItemIds, filters, this.getDefaultHeaders({ curriculumId: curriculumId }))];
                    case 1:
                        itemStandards = _a.sent();
                        return [2 /*return*/, itemStandards.map(function (itemStandard) {
                                return _this.standardSerializer.serializeItemStandard(itemStandard);
                            })];
                }
            });
        });
    };
    StandardService.prototype.findByGlobalId = function (globalIds, include) {
        return __awaiter(this, void 0, void 0, function () {
            var standardItem;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.standardItemClient.findByGlobalId(globalIds, include, __assign(__assign({}, this.getDefaultHeaders()), { 'filter-flag': 'false' }))];
                    case 1:
                        standardItem = _a.sent();
                        return [2 /*return*/, standardItem.map(function (dto) {
                                return _this.standardItemSerializer.serializeOne(dto);
                            })];
                }
            });
        });
    };
    StandardService.prototype.findByAssessmentTemplateId = function (assessmentTemplateIds, filters, curriculumId) {
        return __awaiter(this, void 0, void 0, function () {
            var assessmentTemplateItemStandards;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.itemStandardClient.findByAssessmentTemplateId((0, uniq_1.default)(assessmentTemplateIds), filters.standardSetGlobalIds, filters.hierarchyLevels, this.getDefaultHeaders({ curriculumId: curriculumId }))];
                    case 1:
                        assessmentTemplateItemStandards = _a.sent();
                        return [2 /*return*/, assessmentTemplateItemStandards.map(function (assessmentTemplateItemStandard) {
                                return _this.standardSerializer.serializeAssessmentTemplateItemStandard(assessmentTemplateItemStandard);
                            })];
                }
            });
        });
    };
    StandardService.prototype.findByGlobalIdAddHierarchyTreeAndOrder = function (standardsGlobalIds) {
        return __awaiter(this, void 0, void 0, function () {
            var hierarchyTreeStandardSets;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.standardItemClient.findByGlobalIdAddHierarchyTreeAndOrder(standardsGlobalIds, {
                            ancestors: true,
                            children: false,
                            examples: false,
                            skipValidateStandardSets: true,
                        }, this.getDefaultHeaders())];
                    case 1:
                        hierarchyTreeStandardSets = _a.sent();
                        return [2 /*return*/, hierarchyTreeStandardSets];
                }
            });
        });
    };
    StandardService.prototype.getStandardSets = function (subject) {
        return __awaiter(this, void 0, void 0, function () {
            var response, standardsData, searchTags, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.standardApiV2Client.get('v1/standard-set')];
                    case 1:
                        response = _a.sent();
                        standardsData = response.body;
                        searchTags = standardsData
                            .filter(function (tag) { return "".concat(tag.subject).toLowerCase() === subject.toLowerCase(); })
                            .map(function (tag) { return ({
                            type: tag.displayName,
                        }); });
                        return [2 /*return*/, searchTags];
                    case 2:
                        error_1 = _a.sent();
                        console.error('Error getting standard sets:', error_1);
                        return [2 /*return*/, []];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return StandardService;
}(base_service_1.BaseService));
exports.StandardService = StandardService;
